<template>
  <validation-observer ref="simpleRules">
    <b-card-code
      :title="$route.name == 'detail-keluhan' ? 'Form Detail Keluhan' : 'Form Edit Keluhan'"
      :class="$route.name == 'detail-keluhan' ? 'detail-dispo' : '' "
    >
      <b-button
        v-show="$route.name === 'detail-keluhan' && authorize"
        variant="outline-primary"
        class="bg-gradient-primary mt-2"
        style="position: absolute;right: 15px;top: -10px;"
        type="submit"
        @click.prevent="goEdit()"
      >
        <span class="align-middle">Edit Keluhan</span>
      </b-button>

      <b-row class="match-height">
        <b-col
          md="6"
          class="mb-2"
        >
          <validation-provider
            #default="{ errors }"
            name="No. Keluhan"
            rules="required"
          >
            <b-form-group
              label="No. Keluhan"
              label-for="No. Keluhan"
            >
              <b-form-input
                id="Perihal"
                v-model="code"
                disabled
                placeholder="Tulis Code"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col
          md="6"
          class="mb-2"
        >
          <validation-provider
            #default="{ errors }"
            name="Perihal"
            rules="required"
          >
            <b-form-group
              label="Perihal"
              label-for="Perihal"
            >
              <b-form-input
                id="Perihal"
                v-model="Perihal"
                placeholder="Tulis Perihal"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="{ errors }"
            name="Kontak"
            rules="required"
          >
            <b-form-group
              label="Kontak"
              label-for="Kontak"
            >
              <b-form-input
                id="Kontak"
                v-model="contact"
                placeholder="Tulis Kontak"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <b-form-group
            label="Kategori"
            label-for="Kategori"
          >
            <b-form-select
              v-model="Kategori"
              :options="optionsKategori"
              placeholder="Pilih Kategori"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col md="6">
          <validation-provider
            #default="{ errors }"
            name="Tanggal"
            rules="required"
          >
            <b-form-group
              label="Tanggal"
              label-for="Tanggal"
            >
              <b-form-datepicker
                id="date-datepicker"
                v-model="date"
                locale="id"
                class="mb-1"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <h5 class="titlerow mt-1">
            File Keluhan
          </h5>
          <b-form-group label-for="FileSurat">

            <b-row
              v-if="gantiFile === false && file !== null"
              class="match-height"
            >
              <b-col
                v-for="item in file"
                :key="item.access_url"
                md="12"
                class="fileSurat"
              >
                <div
                  class="open-file"
                  @click="openFile(item.access_url)"
                >
                  <feather-icon
                    icon="FileIcon"
                    size="56"
                  />
                  <h5 class="ml-1">
                    Open File
                    <span> {{ item.real_filename }}{{ item.ext }} </span>
                  </h5>
                </div>
              </b-col>

              <b-button
                v-show="$route.name === 'edit-keluhan'"
                v-model="gantiFile"
                variant="outline-primary"
                class="bg-gradient-primary mt-1 ml-1"
                style="height: 29px"
                size="sm"
                @click.prevent="toggleFile()"
              >
                <span class="align-middle">Ganti File</span>
              </b-button>
            </b-row>

            <b-row v-else>
              <b-col md="12">
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  flex-wrap: wrap;">
                  <b-form-file
                    id="FileSurat"
                    ref="file"
                    v-model="file"
                    type="file"
                    placeholder="Input File Surat"
                    drop-placeholder="Drop file here..."
                    multiple="multiple"
                    @change="fileChange"
                  />

                  <b-button
                    v-show="file !== null"
                    v-model="gantiFile"
                    size="sm"
                    variant="outline-primary"
                    class="bg-gradient-primary mt-1"
                    @click.prevent="toggleFile"
                  >
                    <span class="align-middle">Open File</span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form-group>

          <validation-provider
            #default="{ errors }"
            name="FileSurat"
            rules="required"
          >
            <b-form-group
              label="Tag"
              label-for="tag"
            >

              <b-form-tags
                v-model="tags"
                input-id="tags-basic"
                placeholder="Tambah Tag"
                :disabled="$route.name !== 'edit-keluhan'"
              />
            </b-form-group>
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
        <b-col
          v-show="internal"
          md="6"
        >
          <b-form-group
            label="PIC"
            label-for="PIC"
            class="mt-0"
          >
            <v-select
              v-model="selectedKeputusan"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              placeholder="Pilih PIC"
              :options="optionsKeputusan"
              :disabled="$route.name !== 'edit-keluhan'"
            />
          </b-form-group>

          <b-form-group
            class="mt-2"
            label-for="dilihat"
            label="Divisi/ Bagian/Unit Terkait"
          >
            <v-select
              v-model="selected"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              multiple
              placeholder="Pilih Divisi"
              :options="options"
              :disabled="$route.name !== 'edit-keluhan'"
            />
          </b-form-group>

          <b-form-group
            label="Untuk Diperhatikan"
            label-for="dilihat"
            class="mt-2"
          >
            <v-select
              v-model="selectedViewers"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="text"
              placeholder="Pilih Viewers"
              :options="optionsViewers"
              :disabled="$route.name !== 'edit-keluhan'"
              multiple
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="match-height">
        <b-col md="12">
          <validation-provider
            #default="{ errors }"
            name="keluhan"
            rules="required"
          >
            <label for="textarea-default">Isi Keluhan</label>
            <b-form-textarea
              id="textarea-default"
              v-model="complain"
              placeholder="Tulis Keluhan"
              rows="3"
            />
            <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-col>
      </b-row>

      <b-button
        v-if="$route.name !== 'detail-keluhan'"
        variant="outline-primary"
        class="bg-gradient-primary"
        type="submit"
        @click.prevent="validationForm"
      >
        <span class="align-middle">Simpan</span>
      </b-button>
    </b-card-code>

    <b-card-code
      v-show="internal"
      title="Komentar Keluhan"
      :class="$route.name == 'detail-keluhan' ? 'detail-dispo' : ''"
    >
      <b-row
        class="match-height"
        style="padding:0 30px"
      >
        <b-col md="12">
          <h5 class="mb-1">
            PIC
          </h5>
          <div class="tanggapan">
            <div class="avatar">
              <img
                v-if="selectedKeputusan.avatar === ''"
                :src="require('@/assets/images/icons/user.png')"
              >
              <img
                v-else
                :src="selectedKeputusan.avatar"
              >
            </div>
            <div
              class="input"
              :class="userRole === selectedKeputusan.role_id ? '' : 'uncomment'"
            >
              <div class="komentar-title">
                <h2> {{ selectedKeputusan.text }} </h2>
                <span> {{ komentar1Date ? komentar1Date : '' }} </span>
              </div>
              <b-input-group>
                <div class="komentar">
                  <div class="left">
                    <b-form-input
                      v-model="Komentar1"
                      :disabled="userRole !== selectedKeputusan.role_id"
                      :placeholder="userRole !== selectedKeputusan.role_id ? 'Belum ada komentar' : 'Tulis Komentar Anda'"
                    />
                  </div>
                  <div class="right">
                    <b-button
                      v-show="userRole === selectedKeputusan.role_id"
                      variant="outline-primary"
                      class="bg-gradient-primary btn-sm"
                      style="font-size: 12px;height:unset"
                      @click="kirimKomentar1"
                    >
                      <span class="align-middle"> {{ userRole !== selectedKeputusan.role_id ? 'Tambah Komentar' : 'Update Komentar' }}</span>
                    </b-button>
                  </div>
                </div>
              </b-input-group>
            </div>
          </div>
        </b-col>

        <b-col md="12">
          <h5 class=" mt-3 mb-1">
            Responder
          </h5>
          <b-row>
            <b-col
              v-for="(option, index) in Komentar"
              :key="option.id"
              md="6"
              class="tanggapan mb-2"
            >
              <div class="avatar">
                <img
                  v-if="option.avatar === ''"
                  :src="require('@/assets/images/icons/user.png')"
                >
                <img
                  v-else
                  :src="option.avatar"
                >
              </div>
              <div
                class="input"
                :class="userRole === option.role_id ? '' : 'uncomment'"
              >
                <div class="komentar-title">
                  <h2> {{ option.role_name }} - {{ option.user_name }} </h2>
                  <span> {{ dateFormat(option.updated_at) }} </span>
                </div>
                <b-input-group>
                  <div class="komentar">
                    <div class="left">
                      <b-form-input
                        v-model="Komentar[index].comment"
                        :placeholder="userRole === option.role_id ? 'Tambahkan Komtentar Anda' : 'Belum ada komentar'"
                        :disabled="userRole !== option.role_id"
                      />
                    </div>
                    <div class="right">
                      <b-button
                        v-show="userRole === option.role_id"
                        variant="outline-primary"
                        class="bg-gradient-primary btn-sm"
                        style="font-size: 12px;height:unset"
                        @click="kirimKomentar(index)"
                      >
                        <span class="align-middle"> {{ option.updated_at ? 'Update Komentar' : 'Tambah Komentar' }}</span>
                      </b-button>
                    </div>
                  </div>
                </b-input-group>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card-code>

    <b-row class="match-height">
      <b-col md="7">
        <b-card-code
          title="Status Keluhan"
          style="max-height: 200px;"
        >
          <v-select
            v-model="selectedPerintah"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="text"
            :disabled="!authorize"
            placeholder="Pilih Status"
            :options="[{value: 1, text: 'Open' }, {value: 2, text: 'Close' }]"
            class="mb-2"
          />
          <b-button
            v-b-modal.modal-primary
            :disabled="selectedPerintah.length === 0 || !authorize"
            variant="outline-primary"
            class="bg-gradient-primary mt-2"
            type="submit"
            @click="modal =!modal"
          >
            <feather-icon
              icon="SaveIcon"
              class="mr-50"
            />
            <span class="align-middle">Simpan</span>
          </b-button>
        </b-card-code>
      </b-col>

      <b-col md="5">
        <b-card-code
          title="Riwayat Keluhan"
          class="activity"
        >
          <app-timeline
            v-for="data in activity"
            :key="data.id"
          >
            <app-timeline-item
              :title="internal ? data.user.name : 'Eksternal'"
              :subtitle="data.message"
              :time="dateFormat(data.updated_at)"
              variant="info"
              style="padding-bottom:20px"
            />
          </app-timeline>
        </b-card-code>
      </b-col>
    </b-row>

    <!-- modal -->
    <b-modal
      id="modal-primary"
      v-model="modal"
      ok-title="Lanjutkan"
      modal-class="modal-primary"
      cancel-variant="outline-secondary"
      cancel-title="Kembali"
      centered
      title="Proses Keluhan"
      no-stacking
      @ok="handleOk()"
    >
      <b-card-text>
        Lanjutkan proses <b> {{ selectedPerintah.text }} </b> Keluhan ?
      </b-card-text>
    </b-modal>

  </validation-observer>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BRow,
  BCol,
  BFormFile,
  BFormTags,
  VBModal,
  BFormCheckboxGroup,
  BFormTextarea,
  BInputGroup,
  BFormDatepicker,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import axios from '@axios'
import vSelect from 'vue-select'
import store from '@/store/index'
import dayjs from 'dayjs'
// import useJwt from '@/auth/jwt/useJwt'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    BFormFile,
    BRow,
    BCol,
    BCardCode,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BFormTags,
    BFormCheckboxGroup,
    BFormTextarea,
    vSelect,
    BFormDatepicker,
    AppTimeline,
    AppTimelineItem,
    BInputGroup,
    VBModal,
  },
  data() {
    return {
      authorize: false,
      authorizeResponder: false,
      Kategori: '',
      deadline: null,
      modal: false,
      gantiFile: false,
      date: null,
      internal: false,
      userRole: '',
      complain: '',
      NoSurat: '',
      code: '',
      contact: '',
      title: '',
      group: '',
      Perihal: '',
      deskripsiPenyelesaian: '',
      optionsKategori: [
        { value: 'transaksi', text: 'Transaksi' },
        { value: 'NonTransaksi', text: 'Non Transaksi' },
        { value: 'layanan', text: 'Layanan' },
        { value: 'produk', text: 'Produk' },
        { value: 'after selling', text: 'After Selling' },
        { value: 'distribusi', text: 'Distribusi' },
      ],
      AllData: [],
      file: [],
      optionsResponder: [],
      optionsKeputusan: [],
      selectedPerintah: [],
      selectedPerintahFinal: [],
      optionsViewers: [{ value: '', text: '' }],
      selectedViewers: [],
      selectedKeputusan: [],
      activity: [],
      tags: [],
      fileID: [],
      selected: [],
      selected2: [],
      options: [],
      Komentar: [],
      Jabatan: '',
      Komentar1: '',
      komentar1Date: '',
    }
  },
  created() {
    this.authorize = store.state.userData.data.is_admin === 1
    this.userRole = store.state.userData.data.role.id
  },
  mounted() {
    this.getDetail()
    this.getResponder()
    this.getViewer()
    this.getDecision()
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.editSurat()
        }
      })
    },

    toggleFile() {
      if (this.gantiFile === false) {
        this.gantiFile = true
      } else {
        this.gantiFile = false
      }
    },

    async getDetail() {
      const param = this.$route.params.pathMatch
      const { data } = await axios.get(`/siap/complaint/detail/${param}`)
      this.internal = data.is_external !== true
      this.code = data.ref_num
      this.Perihal = data.title
      this.contact = data.contact
      this.Kategori = data.category.name
      this.date = data.created_at
      this.complain = data.content
      this.file = data.file
      this.selectedPerintah = {
        value: data.status.id,
        text: data.status.name,
      }
      this.selectedPerintahFinal = {
        value: data.status.id,
        text: data.status.name,
      }
      this.NoSurat = data.ref_num
      this.Komentar1 = data.detail.pic.comment
      this.komentar1Date = data.detail.pic.updated_at === null
        ? ''
        : dayjs(data.detail.pic.updated_at).format('DD-MM-YYYY - HH:mm')
      this.Komentar = data.detail.responder

      this.tags = data.tag.map(e => e.name)
      if (data.is_external !== true) {
        this.selected = data.detail.responder.map(e => ({
          value: e.role_id,
          text: `${e.role_name} - ${e.user_name}`,
          user_id: e.user_id,
          role_id: e.role_id,
          avatar: e.avatar,
          receiver_type: 'Responder',
        }))
        this.selected2 = this.selected
        this.selectedViewers = data.detail.guest.map(e => ({
          value: e.role_id,
          text: `${e.role_name} - ${e.user_name}`,
          user_id: e.user_id,
          role_id: e.role_id,
          avatar: e.avatar,
          receiver_type: 'Guest',
        }))
        this.selectedKeputusan = {
          value: data.detail.pic.role_id,
          text: `${data.detail.pic.role_name} - ${data.detail.pic.user_name}`,
          user_id: data.detail.pic.user_id,
          role_id: data.detail.pic.role_id,
          avatar: data.detail.pic.avatar,
          receiver_type: 'PIC',
        }
        if (
          this.selected.find(e => e.user_id === store.state.userData.data.id)
        ) {
          this.authorizeResponder = true
        } else if (
          this.selectedKeputusan.user_id === store.state.userData.data.id
        ) {
          this.authorizeResponder = true
        } else {
          this.authorizeResponder = false
        }
      }
      this.getActivity()
    },

    openFile(e) {
      window.open(e, '_blank')
    },

    async changeFile() {
      this.editFile = !this.editFile
      const param = Number(this.$route.params.id)
      const { data } = await axios.get(`siap/outgoing/${param}`)
      this.file = data.file
    },

    goEdit() {
      const param = this.$route.params.pathMatch
      window.location.href = `/keluhan/edit-keluhan/${param}`
    },

    async fileChange(e) {
      const formData = new FormData()
      e.target.files.forEach(file => {
        formData.append('files', file)
      })
      const { data } = await axios.post('/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        params: {
          feature: 'Complaint',
        },
      })
      this.file = data.data
    },

    async editSurat() {
      const param = this.$route.params.pathMatch
      const responder = this.selected.map(e => ({
        user_id: e.user_id,
        role_id: e.value,
        receiver_type: e.receiver_type,
      }))
      const viewers = this.selectedViewers.map(e => ({
        user_id: e.user_id,
        role_id: e.value,
        receiver_type: e.receiver_type,
      }))
      await axios
        .post(`siap/complaint/update/${param}`, {
          title: this.Perihal,
          contact: this.contact,
          cat: this.Kategori,
          content: this.complain,
          file: this.file,
          tags: this.tags,
          send_to: viewers
            .concat({
              user_id: this.selectedKeputusan.user_id,
              role_id: this.selectedKeputusan.value,
              receiver_type: this.selectedKeputusan.receiver_type,
            })
            .concat(responder),
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDetail()
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
      this.getDetail()
    },

    async validate() {
      const param = Number(this.$route.params.id)
      await axios
        .post(`siap/outgoing/validate/${param}`, {
          status: this.status,
          note: this.note,
          file: this.validateFile.map(e => e.id),
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async kirimKomentar1() {
      await axios
        .post(`siap/complaint/comment/${this.NoSurat}`, {
          comment: this.Komentar1,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDetail()
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },
    dateFormat(time) {
      const formatted = dayjs(time).format('DD/MM/YYYY (HH:mm)')
      if (formatted === 'Invalid Date') {
        return '-'
      }
      return formatted
    },
    async kirimKomentar(n) {
      await axios
        .post(`siap/complaint/comment/${this.NoSurat}`, {
          comment: this.Komentar[n].comment,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
          this.getDetail()
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },

    async getResponder() {
      const { data } = await axios.get('siap/account/receiver-type', {
        params: {
          feature: 'Complaint',
          show_all: 'true',
        },
      })
      this.options = data.map(e => ({
        value: e.role.id,
        text: `${e.role.name} - ${e.user.name}`,
        user_id: e.user.id,
        role_id: e.role.id,
        avatar: e.user.avatar,
        receiver_type: 'Responder',
      }))
    },

    async getViewer() {
      const { data } = await axios.get('siap/account/receiver-type', {
        params: {
          feature: 'Complaint',
          show_all: 'true',
        },
      })
      this.optionsViewers = data.map(e => ({
        value: e.role.id,
        text: `${e.role.name} - ${e.user.name}`,
        user_id: e.user.id,
        role_id: e.role.id,
        avatar: e.user.avatar,
        receiver_type: 'Guest',
      }))
    },

    async getDecision() {
      const { data } = await axios.get('siap/account/receiver-type', {
        params: {
          feature: 'Complaint',
          // show_by_code: 'A,B',
        },
      })
      this.optionsKeputusan = data.map(e => ({
        value: e.role.id,
        text: `${e.role.name} - ${e.user.name}`,
        user_id: e.user.id,
        role_id: e.role.id,
        avatar: e.user.avatar,
        receiver_type: 'PIC',
      }))
    },

    async getActivity() {
      const param = this.$route.params.pathMatch
      const { data } = await axios.get(`siap/complaint/activity/${param}`)
      this.activity = data.data
    },

    async handleOk() {
      await axios
        .post(`siap/complaint/update/status/${this.NoSurat}`, {
          status: this.selectedPerintah.text,
        })
        .then(response => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'InfoIcon',
                text: response.data.message,
                variant: 'success',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
        .catch(error => {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: 'Error',
                icon: 'InfoIcon',
                text: error.response.data.error.message,
                variant: 'danger',
              },
            },
            {
              position: 'bottom-right',
            },
          )
        })
    },
  },
}
</script>
<style lang="scss" >
@import "@core/scss/vue/libs/vue-select.scss";
.row {
  margin-bottom: 20px;
}
.form-group {
  margin-bottom: 5px;
}
.nopad {
  padding: 0;
}
.labelfull {
  .custom-checkbox {
    width: 100%;
  }
}
.labelfull .custom-checkbox {
  width: 100%;
}

.detail-dispo {
  .form-control,
  .custom-select {
    border: unset;
    border-bottom: 1px solid #d8d6de;
    border-radius: 0;
    pointer-events: none;
  }
}

.fileSurat {
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: #a6a6a6;
    display: block;
    margin-top: 5px;
    font-size: 12px;
  }
}

.tanggapan {
  display: flex;
  align-items: center;
  justify-content: space-around;
  .komentar-title {
    display: flex;
    align-items: baseline;
    span {
      font-size: 13px;
      margin-left: 10px;
    }
  }
  .komentar {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
    .left {
      flex-grow: 1;
      margin-right: 10px;
      span {
        font-size: 14px;
        display: block;
        flex-grow: 1;
        margin-right: 10px;
      }
    }
  }
  .uncomment {
    input {
      border: unset !important;
      // border-left: solid 1px !important;
      border-radius: 0 !important;
      padding-left: 0;
      background: #fff;
      color: #5e5873;
    }
  }
  input {
    border: 1px solid #d8d6de !important;
    pointer-events: unset !important;
  }
  .avatar {
    width: 70px;
    height: 70px;
    border: solid 1px #9e9e9e;
    img {
      width: 100%;
      height: intrinsic;
      object-fit: cover;
    }
  }
  h2 {
    font-size: 16px;
  }
  h3 {
    font-size: 14px;
  }
  .input {
    margin-left: 25px;
    flex-grow: 1;
  }
  .input-group-append {
    cursor: pointer;
  }
  .input-group-text {
    background-image: linear-gradient(47deg, #00427a, #005ead);
    color: #fff;
  }
  .btn {
    height: 38px;
  }
}

[dir] .vs--disabled .vs__selected {
  background-color: #00427a;
  color: #fff;
}

.custom-control-input[disabled] ~ .custom-control-label,
.custom-control-input:disabled ~ .custom-control-label {
  color: #615f6f;
}

.open-file {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
  padding: 10px;
  border-radius: 14px;
  transition: background-color 0.5s ease;
  &:hover {
    background: #efefef;
  }
}
.form-group {
  position: relative;
}
.warning {
  font-size: 11px;
  color: orange;
  position: absolute;
  top: 0;
  right: 15px;
}

.activity {
  .card-body {
    max-height: 400px;
    overflow-y: scroll;
  }
}
</style>
